import Button from "./button";
import { IoAdd } from "react-icons/io5";

export default function ButtonAdd(props) {
    const { children } = props;

    return <Button { ...props } className="button--blue" leftIcon={<IoAdd style={{ width: '24px', height: '24px' }}/>}>{ children ? children : 'Add' }</Button>
}